import { SkyMessageBar, type SkyMessageBarProps } from "@skypointcloud/skypoint-ui";
import { useLayoutEffect, useRef } from "react";

/**
 * A `SkyMessageBar` that is page content, not an announcement.
 *
 * The library hard-codes `role="alert"` + `aria-live="assertive"` on every error and warning bar,
 * with no prop to turn them off. On Overview a bar is standing state (an open failure, an unbound
 * destination), and the screen re-reads every 30 seconds: left live, an alert that appears on a
 * refresh would interrupt whatever the reader is doing, and four of them would be read on every
 * arrival. The attributes are removed through the forwarded ref before paint, exactly as P13a's
 * `NoticeRegion` does for its bars (ux-s10.md §3: one element announces, and it is not this one).
 */
export function QuietMessageBar(props: SkyMessageBarProps) {
  const ref = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    ref.current?.removeAttribute("role");
    ref.current?.removeAttribute("aria-live");
  });
  return <SkyMessageBar ref={ref} {...props} />;
}
